import { render } from "./footer.vue?vue&type=template&id=c11a0610&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=c11a0610&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c11a0610"]])

export default __exports__